module.exports = __webpack_public_path__ + "img/queue-forest.0e5873dc.png";